import React from "react";
import Hoc from "../../components/HOC";
import AdminDashboard from "./AdminDashboard";
import EmployeeDashboard from "./EmployeeDashboard";
import { getValuesFromLocalstorage } from "../../components/Helpers";
import UserLandingPage from "./UserLandingPage"

const Dashboard = () => {
  const userDetails = getValuesFromLocalstorage("userDetails");
  return userDetails?.acctType === "ADMIN" ? <AdminDashboard /> : <UserLandingPage />
};

export default Hoc(Dashboard);
